import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Columns from 'support/columns'
import * as Filters from 'support/filters'
import SmartIndexLayout from 'layouts/crud/SmartIndexLayout'
import ViewAdminUserSmartview from 'widgets/smartviews/users/ViewAdminUserSmartview'
import CreateAdminUserSmartview from 'widgets/smartviews/users/CreateAdminUserSmartview'

export default class Index extends CrudPageContent {
  get resourceName () {
    return 'users.admins'
  }

  get layout () {
    return SmartIndexLayout
  }

  get filters () {
    return (
      <>
        <Filters.SearchFilter />
      </>
    )
  }

  get columns () {
    return (
      <>
        <Columns.Text name='name' label='Navn' />
        <Columns.Text name='email' />
      </>
    )
  }

  renderAfterCrud () {
    return null
  }

  get crudProps () {
    return {
      ...super.crudProps,
      createLabel: 'Opret bruger',
      createSmartview: <CreateAdminUserSmartview />,
      smartview: <ViewAdminUserSmartview />
    }
  }
}
